export enum Envs {
  local = 'local',
  prod = 'prod',
  qa = 'qa',
  test = 'test',
}

export enum LocaleId {
  en = 'en',
}

export enum BusinessUnit {
  us = 'us',
}
